/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const useCases = [
    {
        title: 'ERP Organization Wide',
        desc: 'Unify operations across Sales, Supply Chain, HR, and Finance into a single source of truth.',
        color: 'primary'
    },
    {
        title: 'B2B & Partner Portals',
        desc: 'Secure, role-based gateways for vendors, partners, and customers to interact with your data.',
        color: 'secondary'
    },
    {
        title: 'Data Engineering Endpoints',
        desc: 'Use Arcee as the front door and tenancy layer for data products, exposing curated data domains to business users.',
        color: 'info'
    },
    {
        title: 'B2C Applications',
        desc: 'Launch high-performance consumer apps that scale instantly to millions of users without infrastructure headaches.',
        color: 'success'
    }
];

function UseCasesSection() {
    const { theme } = useTheme();

    return (
        <section id="use-cases" className="py-5" style={{ background: '#f8f9fa' }}>
            <div className="container py-5">
                <h2 className="fw-bold display-4 mb-5 text-center" style={{ color: theme.primary }}>
                    Ideal For...
                </h2>
                <div className="row g-4">
                    {useCases.map((useCase, index) => (
                        <div className="col-lg-3 col-md-6" key={index}>
                            <div
                                className="h-100 p-4 bg-white shadow-sm d-flex flex-column justify-content-center text-center"
                                style={{ borderRadius: theme.cardRadius, borderTop: `4px solid ${theme.primary}` }}
                            >
                                <h4 className="fw-bold mb-3">{useCase.title}</h4>
                                <p className="text-muted mb-0 lead fs-6">
                                    {useCase.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default UseCasesSection;
